import React, { useContext, useRef, useEffect } from "react";
import TouchContext from "../../context/touches/touchesContext";
const TouchFilter = () => {
  const touchContext = useContext(TouchContext);
  const { filterTouches, clearFilter, filtered } = touchContext;

  const text = useRef("");

  useEffect(() => {
    if (filtered === null) {
      text.current.value = "";
    }
  });

  const onChange = e => {
    if (text.current.value !== "") {
      filterTouches(e.target.value);
    } else {
      clearFilter();
    }
  };

  return (
    <form>
      <input
        ref={text}
        type="text"
        placeholder="Filter Touches"
        onChange={onChange}
      />
    </form>
  );
};

export default TouchFilter;
